import React from 'react';
import { Hero } from './components/Hero';
import { ProblemSection } from './components/ProblemSection';
import { BenefitsSection } from './components/BenefitsSection';
import { TestimonialsSection } from './components/TestimonialsSection';
import { BonusSection } from './components/BonusSection';
import { PricingSection } from './components/PricingSection';
import { GuaranteeSection } from './components/GuaranteeSection';
import { FAQSection } from './components/FAQSection';
import { Footer } from './components/Footer';
import { SocialProofPopup } from './components/SocialProofPopup';
export function App() {
  const scrollToPricing = () => {
    const pricingSection = document.getElementById('comprar');
    if (pricingSection) {
      pricingSection.scrollIntoView({
        behavior: 'smooth'
      });
    }
  };
  return <div className="min-h-screen bg-brand-dark selection:bg-brand-accent selection:text-white" data-id="element-0">
      <Hero onCtaClick={scrollToPricing} data-id="element-1" />
      <ProblemSection data-id="element-2" />
      <BenefitsSection data-id="element-3" />
      <TestimonialsSection data-id="element-4" />
      <BonusSection onImageClick={scrollToPricing} data-id="element-5" />
      <PricingSection data-id="element-6" />
      <GuaranteeSection data-id="element-7" />
      <FAQSection data-id="element-8" />
      <Footer data-id="element-9" />
      <SocialProofPopup data-id="element-10" />
    </div>;
}